import { Button } from '@mui/material';
import { ICONS } from '@navbar/utils';
import clsx from 'clsx';
import { createElement } from 'react';

interface HeaderProps {
    handleSetDialogLeaveCompanyAsUser: () => void;
}

const UserHeader = ({ handleSetDialogLeaveCompanyAsUser }: HeaderProps) => {
    const LogOutImage = () => {
        return createElement(ICONS.company_leave, {
            className: clsx('h-6 w-6'),
        });
    };
    return (
        <div className="flex flex-row justify-end items-center">
            <Button
                variant="contained"
                color="primary"
                sx={{ m: 1, minWidth: 120, maxHeight: 40 }}
                startIcon={<LogOutImage />}
                onClick={handleSetDialogLeaveCompanyAsUser}
            >
                Leave Company
            </Button>
        </div>
    );
};

export { UserHeader };
